/* !
 * products.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	let moreText = 'more...';
	let closeText = 'close';
	if (FUNCTIONS.va.region === '/jp/') {
		moreText = 'もっと見る';
		closeText = '閉じる';
	}

	// [一覧系共通] サマリー moreボタン開閉
	const prodListSummaryMoreView = () => {
		const a = 'is-active';
		const o = 'is-open';
		let MAXH = 98; // 3行分
		if (FUNCTIONS.va.region === '/jp/' || FUNCTIONS.va.region === '/cn/' || FUNCTIONS.va.region === '/kr/') {
			MAXH = 89;
		}

		document.querySelectorAll('.products-prodList .__summary').forEach(ele => {
			if (ele.clientHeight > MAXH) {
				ele.setAttribute('data-height', ele.clientHeight);
				ele.style.height = `${MAXH}px`;
				ele.querySelector('.__more').classList.add(a);
			}
		});
		document.querySelectorAll('.products-prodList .__more span').forEach(ele => {
			ele.addEventListener('click', () => {
				if (ele.closest('.__more').classList.contains(o)) {
					ele.closest('.__summary').style.height = `${MAXH}px`;
					ele.textContent = `${moreText}`;
					ele.closest('.__more').classList.remove(o);
				} else {
					let thisH = ele.closest('.__summary').getAttribute('data-height');
					ele.closest('.__summary').style.height = `${Number(thisH) + 20}px`;
					ele.textContent = closeText;
					ele.closest('.__more').classList.add(o);
				}
			});
		});
	};

	// [一覧系共通] サブカテゴリのリンクURL正規化
	const adjustProdListSubCatURL = () => {
		document.querySelectorAll('.products-prodList .__subCategory a').forEach(ele => {
			if (ele.getAttribute('href')) {
				let subCatID = ele.getAttribute('href').slice(-4).slice(0, 3);
				let jsonURL = `${FUNCTIONS.va.region}ajax/products/parent_category/${subCatID}`;
				fetch(jsonURL).then(response => response.json()).then(data => {
					const parentID = data.rt_bn_product_category[0]._key;
					ele.setAttribute('href', ele.getAttribute('href').replace(/000/, parentID));
				});
			}
		});
	};

	// [大カテゴリ製品一覧] 製品一覧＋見出しをAJAXで出力
	const setProdListMainCategory = () => {
		const mainCat = location.pathname.slice(-4).slice(0, 3);

		// サブカテゴリごとのセクションをナビの順番通りに生成
		document.querySelectorAll('.products-categoryNav .rt_product_sub_category_link').forEach(ele => {
			let newSection = document.createElement('section');
			newSection.classList.add('products-categorySection', 'mod-auto-pc', 'mod-spacer', 'js-fade');
			newSection.setAttribute('data-id', ele.getAttribute('href').slice(-4).slice(0, 3));
			newSection.setAttribute('data-title', ele.textContent);
			let lastSec = document.querySelectorAll('.products-categorySection')[document.querySelectorAll('.products-categorySection').length - 1];
			lastSec.parentNode.insertBefore(newSection, lastSec.nextElementSibling);
		});
		// テンプレート部分は消す
		document.querySelectorAll('.products-categorySection')[0].remove();

		// AJAXで各セクション内を埋める
		let promiseArr = [];
		document.querySelectorAll('.products-categorySection').forEach(ele => {
			let jsonURL = `${FUNCTIONS.va.region}ajax/products/category/${mainCat}/${ele.getAttribute('data-id')}`;
			let xhr = new XMLHttpRequest();
			let promise = new Promise((resolve, reject) => {
				fetch(jsonURL).then(response => response.json()).then(data => {
					if (data) {
						if (data.rt_bn_product_data) {
							const prodArr = data.rt_bn_product_data;
							let appendSection = `<h3 class="mod-head03 mod-auto-sp">${ele.getAttribute('data-title')}</h3><ul class="products-prodList">`;
							prodArr.forEach(prodItem => {
								appendSection += `<li class="__item"><a href="${prodItem.rt_product_link.href}">` +
									`<figure><img src="${prodItem.rt_p_image.src}" alt="${prodItem.rt_p_image.alt}" loading="lazy">`;

								// 未発売商品の帯表示
								switch (FUNCTIONS.va.region) {
									case '/':
										if (prodItem.rt_p_notsell_Global) {
											if (prodItem.rt_p_notsell_Global.content === '1') {
												appendSection += '<figcaption class="__unreleased">This product is not available yet.</figcaption>';
											}
										}
										break;
									case '/jp/':
										if (prodItem.rt_p_notsell_TRK) {
											if (prodItem.rt_p_notsell_TRK.content === '1') {
												appendSection += '<figcaption class="__unreleased">本製品は日本国内では、<br>お取り扱いがありません。</figcaption>';
											}
										}
										break;
									default: break;
								}

								appendSection += `</figure></a>` +
									`<div class="__text"><h3><a href="${prodItem.rt_product_link.href}"><span>${prodItem.rt_p_name.content}</span></a></h3>` +
									`<div class="__summary"><div>${prodItem.rt_p_summary.content}</div><span class="__more"><span>${moreText}</span></span></div>` +
									`<ul class="mod-tagList">`;

								// 事業ラベル
								if (prodItem.rt_bc_retail) {
									appendSection += `<li><a href="${prodItem.rt_bc_retail.href}">${prodItem.rt_bc_retail.content}</a></li>`;
								}
								if (prodItem.rt_bc_logistics) {
									appendSection += `<li><a href="${prodItem.rt_bc_logistics.href}">${prodItem.rt_bc_logistics.content}</a></li>`;
								}
								if (prodItem.rt_bc_food) {
									appendSection += `<li><a href="${prodItem.rt_bc_food.href}">${prodItem.rt_bc_food.content}</a></li>`;
								}
								if (prodItem.rt_bc_hospitality) {
									appendSection += `<li><a href="${prodItem.rt_bc_hospitality.href}">${prodItem.rt_bc_hospitality.content}</a></li>`;
								}
								appendSection += '</ul>';

								// サブカテゴリ
								switch (FUNCTIONS.va.region) {
									case '/jp/': appendSection += '<h4>製品分野</h4><ul class="__subCategory">'; break;
									case '/be/nl/': appendSection += '<h4>Productcategorieën</h4><ul class="__subCategory">'; break;
									case '/be/fr/': appendSection += '<h4>Catégories de produits</h4><ul class="__subCategory">'; break;
									case '/ca/fr/': appendSection += '<h4>Catégories de produits</h4><ul class="__subCategory">'; break;
									case '/fr/': appendSection += '<h4>Catégories de produits</h4><ul class="__subCategory">'; break;
									case '/de/': appendSection += '<h4>Produktkategorien</h4><ul class="__subCategory">'; break;
									case '/es/': appendSection += '<h4>Categorías de Producto</h4><ul class="__subCategory">'; break;
									case '/it/': appendSection += '<h4>Categorie di Prodotto</h4><ul class="__subCategory">'; break;
									case '/tr/': appendSection += '<h4>Ürün kategorileri</h4><ul class="__subCategory">'; break;
									case '/cn/': appendSection += '<h4>产品类别</h4><ul class="__subCategory">'; break;
									case '/kr/': appendSection += '<h4>제품 카테고리</h4><ul class="__subCategory">'; break;
									default: appendSection += '<h4>Product categories</h4><ul class="__subCategory">'; break;
								}
								prodItem.pb_category.forEach(prodSubCat => {
									if (prodSubCat.rt_category_link) {
										appendSection += `<li><a href="${prodSubCat.rt_category_link.href}" class="mod-link01">${prodSubCat.rt_category_link.content}</a></li>`;
									}
								});

								appendSection += `</ul></div></li>`;
							});
							appendSection += '</ul>';
							ele.innerHTML = appendSection;
						} else {
							ele.remove();
						}
						resolve(xhr.responseText);
					} else {
						reject(xhr.statusText);
					}
				});
			});
			promiseArr.push(promise);
		});

		Promise.all(promiseArr).then(result => {
			prodListSummaryMoreView();
		}).catch((error) => {
			console.error('AJAX ERROR');
		});
	};

	// [モデルから探す] 空のliを削除⇒空の項目を削除
	const removeEmptyModelLink = () => {
		document.querySelectorAll('.rt_bn_product_initial').forEach(ele => {
			if (!ele.getElementsByTagName('a').length) { ele.remove(); }
		});
		document.querySelectorAll('.products-wordList').forEach(ele => {
			if (!ele.getElementsByTagName('li').length) {
				let thisID = ele.getAttribute('id').replace(/model/, 'word');
				ele.remove();
				document.getElementById(thisID).classList.add('is-disabled');
			}
		});
	}

	// [詳細] フリーレイアウト版のiframeの高さ調整
	const adjustProdDetailFreeIframe = () => {
		let $iframe = document.querySelector('.products-detail-free iframe.rt_p_page_file_path');
		$iframe.style.height = $iframe.contentWindow.document.body.scrollHeight + 'px';
	};

	// [詳細] 外形寸法図がない場合見出し削除
	const removeDimensionsHead = () => {
		if (document.querySelectorAll('.rt_p_spec_images_is').length === 0 && document.querySelector('.__dimensionsHead')) {
			document.querySelector('.__dimensionsHead').remove();
		}
	};

	// [詳細] 関連製品の並び替え処理
	const adjustRelatedItemSort = () => {
		if (document.querySelector('.products-detail-related.__product')) {
			let adjustItemList = [];
			let relatedItems = document.querySelectorAll('.products-detail-related.__product .rt_bn_related_products_data');
			let itemID = FUNCTIONS.va.pathname.replace(FUNCTIONS.va.region, '').split('/')[1];
			let jsonURL = `${FUNCTIONS.va.region}ajax/products/rel_list_order/${itemID}`;
			fetch(jsonURL).then(response => response.json()).then(data => {
				data.product_Base[0].pb_related_products.forEach(keys => {
					relatedItems.forEach(item => {
						if (item.querySelector('a').getAttribute('data-id').indexOf(keys._key) !== -1) {
							adjustItemList.push(item);
						}
					});
				});
				document.querySelectorAll('.products-detail-related.__product .rt_bn_related_products_data').forEach(ele => { ele.remove(); });
				adjustItemList.forEach(ele => {
					document.querySelector('.products-detail-related.__product .mod-prodList').append(ele);
				});
			});
		}
	};

	// ------------------------------------------- ↑↑ functions ↑↑ -------------------------------------------

	prodListSummaryMoreView();
	adjustProdListSubCatURL();

	if (location.pathname.indexOf('/category/') !== -1 && document.querySelector('.products-categoryNav .rt_breadcrumb_parent_href')) {
		if (document.querySelector('.products-categoryNav .rt_breadcrumb_parent_href').getAttribute('href') === location.pathname) {
			setProdListMainCategory();
		}
	}
	if (location.pathname.indexOf('/model/') !== -1) {
		removeEmptyModelLink();
	}
	if (document.querySelector('.products-detail')) {
		removeDimensionsHead();
		adjustRelatedItemSort();
		if (document.querySelector('.products-detail-free iframe.rt_p_page_file_path')) {
			window.addEventListener('load', () => { adjustProdDetailFreeIframe(); });
			window.addEventListener('resize', () => { adjustProdDetailFreeIframe(); });
		}
	}

})(window.FUNCTIONS);
